import { useState } from 'react';
import { noop } from 'lodash';
import { Field } from 'react-final-form';
import { useTranslation } from '../../../../utils/useTranslation';
import { IconChecked } from '../../../icon/IconChecked';
import { FormControl } from '../../../input/FormControl';
import { Input } from '../../../input/Input';
import { Box } from '../../../layout/Box';
import { Menu, MenuItem } from '../../../navigation/Menu';
import { Typography } from '../../../typography/Typography';
import { DropdownFieldProps } from '../types';

export const DropdownField = ({ name, label, values, required }: DropdownFieldProps) => {
    const t = useTranslation();
    const [inputValue, setInputValue] = useState(values[0]);

    return (
        <Field
            name={name}
            render={({ input, meta }) => (
                <FormControl
                    pt={1}
                    pb={1}
                    label={t(label)}
                    required={required}
                    error={meta.touched ? Boolean(meta.error) : undefined}
                    message={meta.touched ? meta.error : undefined}
                >
                    <>
                        <Menu
                            zIndex={9999}
                            options={{ placement: 'bottom-start' }}
                            width="100%"
                            trigger={
                                <Box width="100%">
                                    <Input {...input} value={inputValue} onChange={noop} />
                                </Box>
                            }
                        >
                            {values.map((value) => (
                                <MenuItem
                                    key={value}
                                    spacing={1}
                                    direction="row"
                                    justifyContent="space-between"
                                    onClick={() => setInputValue(value)}
                                >
                                    <Typography variant="body" noWrap>
                                        {value}
                                    </Typography>
                                    <IconChecked
                                        size={20}
                                        color={
                                            value === inputValue
                                                ? 'var(--color-primary)'
                                                : 'transparent'
                                        }
                                    />
                                </MenuItem>
                            ))}
                        </Menu>
                    </>
                </FormControl>
            )}
        />
    );
};
